import QuestionWrapper from "@/components/pages/registration/questions/QuestionWrapper";

export default {
    components: {QuestionWrapper},
    props: {
        question: {
            type: Object,
            required: true
        },
        registrarMode: {
            type: Boolean,
            required: true
        }
    }
}